<template>
    <div class="social">
        <div></div>
            
        <div>
        
        <social-sharing url="https://commutesum.com/"
                      :title="$t('social-sharing.title')"
                      :description="$t('social-sharing.description')"
                      :hashtags="$t('social-sharing.hashtags')"
                      inline-template>
          <div>
              
                <network network="whatsapp">
                <i class="fa fa-whatsapp"> <img src="icons/social-whatsapp_30.png" alt="Whatsapp" title="Whatsapp" /> </i>
              </network>
              
              <network network="reddit">
                <i class="fa fa-reddit"> <img src="icons/social-reddit_30.png" alt="Reddit" title="Reddit" /> </i>
              </network>
              
              <network network="pinterest">
                <i class="fa fa-pinterest"> <img src="icons/social-pinterest_30.png" alt="Pinterest" title="Pinterest" />    </i>
              </network>
              
              <network network="facebook">
                <i class="fa fa-facebook">  <img src="icons/social-facebook_30.png" alt="Facebook" title="Facebook" />  </i>
              </network>
              
               <network network="twitter">
                <i class="fa fa-twitter"> <img src="icons/social-twitter_30.png" alt="Twitter" title="Twitter" /> </i>
              </network>
              
              <network network="linkedin">
                <i class="fa fa-linkedin"> <img src="icons/social-linkedin_30.png" alt="LinkedIn" title="LinkedIn" />    </i>
              </network>
              
              <network network="email">
                  <i class="fa fa-envelope">  <img src="icons/social-email_30.png" alt="Email" title="Email" /></i>
              </network>
              
             
            
          </div>
        </social-sharing>
        </div>
    <div></div>  
    </div>  

</template>

<script>

import SocialSharing from 'vue-social-sharing'


export default {
    components: {
        SocialSharing
    },
    data: function(){
        return {
        
        }
    },
    props: {
    },
    created() {
    },
    
    computed : {
    
    },
    methods: {
    }
}
    

</script>

<style>

.fa img{
    padding: 5px;
    margin: 5px;
}

.fa img:hover{
    padding-bottom: 3px;
    border-bottom: 2px solid red;
    cursor: pointer;
}


</style>